import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import AventiorLogo2 from "../../assets/CPV-Auto-logo-Final.png";
import "./CAMHeader.scss";
import { useNavigate } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as acts from "../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { action } from "../../constants/action";
import { Divider, SwipeableDrawer } from "@mui/material";
import SettingDrawer from "../SettingsDrawer/SettingsDrawer";
import auth from "../../config/auth";
import Label from "../Label/Label";
import { investigatorRoutes } from "../../routes/routeConstants";
import { format } from "date-fns";
import Snackbar from "../../components/Snackbars/CustomizedSnackbars";

export default function CAMHeader(props) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openSettingDrawer, setOpenSettingDrawer] = useState(false);
  const navigate = useNavigate();
  const userLogout = useSelector((state) => state?.auth?.userLogout);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (userLogout?.apiSuccess) {
      localStorage.clear();
      navigate("/");
      auth.logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogout]);

  const handleLogout = () => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/");
    } else {
      const showNotification = true;
      dispatch(acts.userLogout(showNotification));
    }

    setAnchorEl(null);
  };

  const handleHome = () => {
    if (localStorage.getItem("userRole") === "investigator") {
      navigate(`/${investigatorRoutes.taskStatus}`);
    }
  };

  const toggleDrawer = (value) => {
    setOpenSettingDrawer(value);
    setAnchorEl(null);
  };

  const [snack, setSnack] = useState("");
  useEffect(() => {
    const listener = (e) => {
      setSnack({
        open: true,
        message: e.detail.message,
        severity: e.detail.type,
      });
    };
    window.addEventListener("showSnackbar", listener);
    return () => window.removeEventListener("showSnackbar", listener);
  }, []);

  const handleClose = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };
  return (
    <>
      <Box
        className="cam-header"
        sx={{ display: "flex", flexGrow: 1, backgroundColor: "gray" }}
      >
        {snack?.open && (
          <Snackbar
            className="popup"
            handleClose={handleClose}
            severity={snack.severity}
            state={snack?.open}
            text={snack?.message}
            autoHide={true}
          />
        )}
        <AppBar position="fixed" sx={{ boxShadow: "none" }}>
          <Toolbar className="toolBar">
            <img
              src={AventiorLogo2}
              className="logo"
              onClick={() => handleHome()}
              alt="AventiorLogo"
            />
            <div className="vertical"></div>
            <Typography variant="subtitle1" className="HeaderProjectName">
              {action?.LOGO} / CAM-SRM 2.1 (MVP)
            </Typography>

            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                paddingRight: "15px",
                alignItems: "flex-end", // aligns content to the right
              }}
            >
              <Label
                text={localStorage?.userName }
                paddingRight={15}
                fontSize="14px"
                fontWeight="500"
              />
              {/* <Typography variant="caption" color="text.secondary"> */}
              <Label
                fontSize="10px"
                text={`Last login:${
                  isNaN(new Date(localStorage.last_login))
                    ? (localStorage.last_login ?? "N/A")
                    : format(new Date(localStorage.last_login), "PPpp")
                }`}
              />
              {/* </Typography> */}
            </Box>

            <IconButton
              size="medium"
              edge="start"
              aria-label="menu"
              onClick={handleClick}
            >
              <MenuIcon
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                className="user-profile-icon"
              />
            </IconButton>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              className="user-profile"
              onClose={(e) => handleCloseMenu(e)}
              MenuListProps={{
                "aria-labelledby": "demo-positioned-button",
              }}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <div className="menu-wrapper">
                <div className="menu-version-wrap">
                  <h3 className="menu-title">About</h3>
                  <div className="menu-details">
                    <p className="app-name">CAM-SRM 2.1 (MVP)</p>
                    <p className="release-date">Released: April 2025</p>
                  </div>
                </div>
                <Divider
                  className="menu-divider"
                  variant="middle"
                  component="li"
                />

                <div className="support-version-wrap">
                  <h3 className="support-title">Need help? </h3>
                  <h3 className="support-title">Contact us at</h3>

                  <div className="support-details">
                    <p className="support-name">
                      <a
                        href="mailto:support@aventior.com"
                        className="support-link"
                      >
                        support@aventior.com
                      </a>
                    </p>
                  </div>
                </div>

                <Divider className="menu-divider" />
                <MenuItem onClick={() => toggleDrawer(true)} disabled>
                  {action.SETTINGS}
                </MenuItem>
                <MenuItem onClick={handleLogout}>{action.LOGOUT}</MenuItem>
              </div>
            </Menu>
          </Toolbar>
        </AppBar>
      </Box>

      <div>
        <React.Fragment key={"right"}>
          <SwipeableDrawer
            className="header-toggle"
            anchor={"right"}
            open={openSettingDrawer}
            onClose={(e) => toggleDrawer(false)}
            onOpen={(e) => toggleDrawer(true)}
          >
            <SettingDrawer onClose={() => toggleDrawer(false)} />
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </>
  );
}
